import { useEffect } from 'react';
import { useApiRequest } from '../../../../../../hooks/useGivingApiRequest';
import { Wallet } from '../../../../../../providers/DonorProvider/interfaces';
import { GivingApiResponse } from '../../../../../../utils/makeApiRequest';
import { User } from '../../../../../LoginModal/routes';
import { checkCardType } from '../../../../../LoginModal/utils';
import { requestRecaptchaV3Token } from '../../../../../Wrappers/ReCaptchaV3';
import { addCardRequest, AddCardResponse } from './api';
import { PaymentRoutes } from './CreditCardForm';

export const useAddCardLogic = ({
  eventName,
  user,
  firstRoute = 'CREDIT',
  addCard,
  setRoute,
  setUser,
  handlePaymentModalClose
}: {
  user: User;
  firstRoute?: PaymentRoutes;
  eventName: string; // any text
  addCard: (card: Wallet) => unknown;
  setRoute: React.Dispatch<React.SetStateAction<PaymentRoutes>>;
  setUser: React.Dispatch<React.SetStateAction<User>>;
  handlePaymentModalClose: () => unknown;
}) => {
  const [requestState, makeRequest] =
    useApiRequest<GivingApiResponse<AddCardResponse>>();

  useEffect(() => {
    if (requestState.type !== 'REQUEST_SUCCESS') {
      return;
    }
    addCard({
      id: requestState.data.response.payload.walletId,
      number: user.card?.cardNumber.slice(-4) || '',
      paymentInstrumentUuid:
        requestState.data.response.payload.paymentInstrumentId,
      type:
        (checkCardType(user.card?.cardNumber || '')?.type as Wallet['type']) ||
        'Visa',
      isPreferred: false
    });
    setRoute(firstRoute);
    setUser({ ...user, card: undefined });
    handlePaymentModalClose();
  }, [requestState.type, addCard, handlePaymentModalClose, setRoute, setUser]);

  const handleSubmit = (user: User) => {
    requestRecaptchaV3Token(
      (token: string | undefined) => {
        makeRequest(addCardRequest(user, token));
      },
      undefined,
      eventName
    );
    setUser(user);
  };

  return { handleSubmit, requestState };
};
